import type { CmlContent as GraphQLCmlContent } from '__generated__/graphql-types-do-not-use';

import type { CmlContent } from 'bundles/cml';

function convertToCmlContent(cml: GraphQLCmlContent): CmlContent {
  return {
    typeName: 'cml',
    definition: {
      dtdId: cml?.dtdId,
      value: cml?.cmlValue,
      renderableHtmlWithMetadata: {
        metadata: cml?.htmlWithMetadata?.metadata,
        renderableHtml: cml?.htmlWithMetadata?.html,
      },
    },
  };
}

export default convertToCmlContent;
